import {HTHSymbol, HTHSymbolStates, ISymbolData} from "./HTHSymbol";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHXNudgeSymbol} from "./HTHXNudgeSymbol";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHXWaysSymbol} from "./HTHXWaysSymbol";
import {HTHXSplitSymbol} from "./HTHXSplitSymbol";
import {HTHWildSymbol} from "./HTHWildSymbol";
import {HTHRemovalSymbol} from "./HTHRemovalSymbol";
import {HTHNormalSymbol} from "./HTHNormalSymbol";
import {HTHMaxWinSymbol} from "./HTHMaxWinSymbol";
import {HTHEnhancerFrame} from "../view/HTHEnhancerFrame";
import {HTHBlankSymbol} from "./HTHBlankSymbol";
import {HTHSound} from "../sound/HTHSound";

export class HTHEnhancerSymbol extends HTHSymbol {

    private _isOpen: boolean;//false-locked , true-unlocked
    private _revealedSymbolContainer: PIXI.Container;
    private _revealSym: HTHSymbol | null;
    private _revealedMultiplier: PIXI.BitmapText;
    private _currentSpine: PIXI.spine.Spine;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates) {
        super(symbolData);
        this._isOpen = false;
        this._firstTimeOpened = false;
        this._isEBFilled = false;
        this._revealedSymName = "";
        this._revealedSymSize = 1;
        this.symSize = this._revealedSymSize;
        this._participatedInWin = false;
        this._revealSym = null;
        this._revealedSymbolContainer = new PIXI.Container();
        this._revealedSymbolContainer.name = "revealedsymbolContainer";
        this.addChild(this._revealedSymbolContainer);

        this.getStateAnimation(state);
        // this.symbolAnimChange(this.reelId === 1 ? "inactive_two" : "inactive_one");
        this.symbolAnimChange("inactive_on_nobg");

    }

    private _revealedSymName: string;

    public get revealedSymName(): string {
        return this._revealedSymName;
    }

    public set revealedSymName(setValue: string) {
        this._revealedSymName = setValue;
    }

    private _revealedSymSize: number;

    public get revealedSymSize(): number {
        return this._revealedSymSize;
    }

    public set revealedSymSize(setValue: number) {
        this._revealedSymSize = setValue;
    }

    private _firstTimeOpened: boolean;

    get firstTimeOpened(): boolean {
        return this._firstTimeOpened;
    }

    set firstTimeOpened(value: boolean) {
        this._firstTimeOpened = value;
    }

    private _isEBFilled: boolean;

    public get isEBFilled(): boolean {
        return this._isEBFilled;
    }

    public set isEBFilled(setValue: boolean) {
        this._isEBFilled = setValue;
    }

    private _participatedInWin: boolean;

    get participatedInWin(): boolean {
        return this._participatedInWin;
    }

    set participatedInWin(value: boolean) {
        this._participatedInWin = value;
    }

    public get isEnhancerOpen(): boolean {
        return this._isOpen;
    }

    public set isEnhancerOpen(setValue: boolean) {
        this._isOpen = setValue;
    }

    public get revealedSymbol(): HTHSymbol | null {
        return this._revealSym;
    }

    public set revealedSymbol(value: HTHSymbol | null) {
        this._revealSym = value;
    }

    public unlockSymbol(isInit: boolean = false): gsap.core.Timeline {
        const unlockTL: gsap.core.Timeline = gsap.timeline();
        if (!this._isOpen) {
            this.symSize = 1;
            this.firstTimeOpened = true;
            this._isOpen = true;
            unlockTL.add(() => {
                HTHEnhancerFrame.fireHighlights[this.reelId - 1].visible = true;

                HTH.reelArea.enhancerFrame.assignMasks(this.reelId);

                HTHEnhancerFrame.fireHighlights[this.reelId - 1].playLoop();
                // HTHEnhancerFrame.blackGraphic.visible=true;
                // HTHEnhancerFrame.blackGraphic.width= 120 * this.reelId -10;
                this.movetoParticularMaskedLayer(HTH.reelArea.allReels[this.reelId].reelView.reelLayers.enhancerBlockOpenedLayer);
            }, 0);
            if (!isInit) {
                if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                    unlockTL.add(this.symbolAnimChange("one_lock_to_none"));
                } else {
                    unlockTL.add(this.symbolAnimChange("one_lock_to_none_nobg"));
                }
                unlockTL.add(() => {
                    HTHSound.playTrack(HTHSound.ENHANCER_CELL_DOOR_LOCK_OFF);
                }, "<");

            }
        }
        return unlockTL;
    }

    public lockSymbol(): gsap.core.Timeline {
        // this.addChild(this._currentSpine);
        this._revealedSymName = "";
        this._revealedSymSize = 1;
        this.symSize = this._revealedSymSize;
        this.firstTimeOpened = true;
        this._isEBFilled = false;
        const shutterDwnTL: gsap.core.Timeline = gsap.timeline();
        if (this.isEnhancerOpen) {
            shutterDwnTL.add(() => {
                HTHEnhancerFrame.fireHighlights[this.reelId - 1].visible = false;
                HTHEnhancerFrame.fireHighlights[this.reelId - 1].stopLoop();
                // HTHEnhancerFrame.blackGraphic.visible=false;
                // HTHEnhancerFrame.blackGraphic.width= 110;
                this.movetoParticularMaskedLayer(HTH.reelArea.allReels[this.reelId].reelView.reelLayers.enhancerBlockLayer);

            }, 0)
            shutterDwnTL.add(this.symbolAnimChange("shutter_down_onechain_nobg"));
        }
        if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE" || HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "BOOSTED_BET_BONUS_HUNT") {
            shutterDwnTL.add(this.symbolAnimChange("inactive_one"));
        } else {
            shutterDwnTL.add(this.symbolAnimChange("inactive_on_nobg"));
        }
        // shutterDwnTL.add(this.symbolAnimChange(this.reelId === 1 ? "inactive_two" : "inactive_one"));
        // shutterDwnTL.add(this.symbolAnimChange("inactive_one"));
        return shutterDwnTL;
    }

    public getStateAnimation(state: HTHSymbolStates = HTHSymbolStates.NORMAL, duration: number = 0): gsap.core.Timeline {
        if (this.symbolState === state) {
            return gsap.timeline();
        }
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
        });
        this._currentSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset(`${this.symName}`));
        this._currentSpine.visible = true;
        this._currentSpine.name = "enhancerBlockSpine";
        this._currentSpine.position.set(0, 0);
        this.addChild(this._currentSpine);
        this.symbolState = state;
        return tl;
    }

    public symbolAnimChange(animName: string): gsap.core.Timeline {
        // this._currentSpine.state.setAnimation(0, `${animName}`, false);
        if (animName === "blank") {
            this.addChild(this._currentSpine);
        }
        return HTHHelper.playSpineWithTimeline(this._currentSpine, 0, `${animName}`);
    }

    public revealedSymbolAnimChange(animName: string): gsap.core.Timeline {
        const playAnimTl: gsap.core.Timeline = gsap.timeline();
        playAnimTl.add(this._revealSym!.animationChange(animName));
        return playAnimTl;
    }

    public revealAnotherSymbol(symName: string, symSize: number): gsap.core.Timeline {
        // if (this._revealedSymbolContainer.children.length === 0) {
        this.revealSymbol(symName, symSize);
        // }
        return gsap.timeline().to(this, {duration: 0.01});
    }

    public fakeRevealAnotherSymbol(symName: string, symSize: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._revealedSymbolContainer.alpha = 0;
            this.emptyRevealContainer();
            this.revealSymbol(symName, symSize);
        }, 0);
        tl.to(this._revealedSymbolContainer, {alpha: 1, duration: 0.01}, 0.01);
        return tl;
    }

    public revealSymbol(revealSymName: string, revealSymSize: number, revealingWild: boolean = false) {
        this.emptyRevealContainer();
        this._participatedInWin = false;
        let revealSym: HTHSymbol;
        const revealSymData: ISymbolData = {
            symName: revealSymName,
            symSize: revealSymName === "RW" ? 0 : revealSymSize,
            id: this.id,
            reelId: this.reelId,
            spinPosition: 0
        }

        if (revealSymName === "XW") {
            revealSym = new HTHXWaysSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "XS") {
            revealSym = new HTHXSplitSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "XN") {
            revealSym = new HTHXNudgeSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "W") {
            revealSym = new HTHWildSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "RW") {
            revealSym = new HTHRemovalSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "MAX") {
            revealSym = new HTHMaxWinSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "EB") {
            revealSymData.symName = "BL";
            revealSym = new HTHBlankSymbol(revealSymData, HTHSymbolStates.BLANK);
        } else {
            revealSym = new HTHNormalSymbol(revealSymData, HTHSymbolStates.NORMAL);
        }

        // this.addChild(this._revealedSymbolContainer);
        this._revealedSymbolContainer.addChild(revealSym);
        this._revealedSymName = revealSymName;
        this._revealedSymSize = revealSymName === "RW" ? 0 : revealSymSize;
        this.symSize = this._revealedSymSize;
        this._revealSym = revealSym;

    }

    public revealXNudgeSize(symNudgedOverId: number, symNudgedOverSymSize: number): gsap.core.Timeline {
        return (<HTHXNudgeSymbol>this._revealedSymbolContainer.children[0]).revealXNudgeSize(symNudgedOverId, symNudgedOverSymSize);
    }

    public playXNudgeAnim(XNSymId: number, isEnhancerOpen: boolean, isRestore: boolean = false): gsap.core.Timeline {
        return (<HTHXNudgeSymbol>this._revealedSymbolContainer.children[0]).playXNudgeAnim(XNSymId, isEnhancerOpen, isRestore);
    }

    public playBikerAnim(XNSymId: number, isEnhancerOpen: boolean): gsap.core.Timeline {
        return (<HTHXNudgeSymbol>this._revealedSymbolContainer.children[0]).playBikerAnim(XNSymId, isEnhancerOpen);
    }

    public updatexNudgeMultiplierForRestore(isRestore: boolean) {
        return (<HTHXNudgeSymbol>this._revealedSymbolContainer.children[0]).updatexNudgeMultiplierForRestore(isRestore);
    }

    public emptyRevealContainer(): void {
        if (this._revealedSymbolContainer.children.length > 0) {
            this._revealedSymbolContainer.children.forEach(item => {
                item.destroy();
            })
            this._revealedSymbolContainer.removeChildren();
            this.revealedSymSize = 1;
            this.symSize = this._revealedSymSize;
            this.revealedSymName = "";
            // this.symbolAnimChange("shutter_down2");
        }
    }

    public removalExplode(): gsap.core.Timeline {
        const remExTL: gsap.core.Timeline = gsap.timeline();
        remExTL.add(() => {
            this.addChild(this._revealedSymbolContainer);
            HTH.reelArea.ebSpinArea.hideSymbol(this.reelId);
            this.symbolAnimChange("open_block");
        }, 0);
        remExTL.to(this, {duration: 0.25});
        remExTL.add(() => {
            this.emptyRevealContainer();
            this.isEBFilled = false;
            // this.symbolAnimChange("shutter_down");
        }, ">");
        return remExTL;
    }

    public showWaysIncrease(ways: number): gsap.core.Timeline {  //removal symbol in enhancer block
        const countupTl: gsap.core.Timeline = gsap.timeline();
        this.revealedSymSize = this.revealedSymSize + ways;
        this.symSize = this._revealedSymSize;
        countupTl.to(((<HTHRemovalSymbol>this._revealSym)).multiplierText, {alpha: 1, duration: 0.3});
        countupTl.add(() => {
            let currentValueOfMultiplier: number = parseInt((<HTHRemovalSymbol>this._revealSym).multiplierText.text.slice(1, (<HTHRemovalSymbol>this._revealSym).multiplierText.text.length));
            (<HTHRemovalSymbol>this._revealSym).updateSymbolMultiplier(currentValueOfMultiplier + ways);
        }, 0);
        return countupTl;
    }

    public highlight(): gsap.core.Timeline {
        const highlightTl: gsap.core.Timeline = gsap.timeline();
        if (this.revealedSymbol) {
            (<HTHSymbol>this.revealedSymbol).playInitialWinEB();
            highlightTl.add(() => {
                (<HTHSymbol>this.revealedSymbol).highlight();
            }, 0);
        }
        return highlightTl;
    }

    public explode(): gsap.core.Timeline {
        let explodeTl: gsap.core.Timeline = gsap.timeline();

        if (this.revealedSymbol) {
            explodeTl.add(() => {
                (<HTHSymbol>this.revealedSymbol).explode();
                this.revealedSymName = "";
                this.revealedSymSize = 1;
                this.symSize = this._revealedSymSize;
            }, 0);
        }
        explodeTl.add(() => {
            this.addChild(this._revealedSymbolContainer);
            HTH.reelArea.ebSpinArea.hideSymbol(this.reelId);
            this.symbolAnimChange("open_block");
        }, 0)
        const miniTl: gsap.core.Timeline = gsap.timeline();
        explodeTl.add(miniTl);
        if (this._revealedSymName !== "RW") {
            explodeTl.to(this._revealedSymbolContainer.children[0], {
                alpha: 0,
                duration: 0.533,
            }, "<");
        }
        explodeTl.add(() => {
            if (this._revealedSymName !== "RW") {
                this.emptyRevealContainer();
            }
            this.isEBFilled = false;
            if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                this.symbolAnimChange("shutter_down");
            }
            else{
                this.symbolAnimChange("shutter_down_blank");
            }
        })
        return explodeTl;
    }

    public checkMultiplier(): void {

    }

    public removeSymbolMultiplier() {
        this._revealedSymbolContainer.removeChild(this._revealedMultiplier);
        this._revealedMultiplier.destroy();
    }

    public resetSpine(): void {
        HTHHelper.resetSpineItem(this._currentSpine);
    }

    public addSplitEffect(size: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        const diff = this.revealedSymSize === 0 ? 1 : this.revealedSymSize;
        if (this.revealedSymName === "RW") {
            tl.add(this.showWaysIncrease(diff * 2));
        } else {
            this.revealedSymSize = this.revealedSymSize === 0 ? 2 : this.revealedSymSize * 2;
            this.symSize = this.revealedSymSize;
            this.revealedSymbol!.symSize = this.revealedSymSize;
        }
        if (this._revealSym?.isNormalSymbol) {
            (<HTHNormalSymbol>this._revealSym).symSize = this.revealedSymSize;
            HTH.reelArea.ebSpinArea.changeSymbol(this.reelId,this._revealedSymName,this._revealedSymSize);
            tl.add((<HTHNormalSymbol>this._revealSym)!.symbolAnimChange(size * 2 <= 5 ? `split${size * 2}` : "split5"));
        }
        if (this.revealedSymName !== "RW") {
            tl.add(this._revealSym!.splitMultiplier(size === 0 ? 2 : size * 2), "<");
        }
        tl.add(() => {
            this.symbolState = this.symbolState !== HTHSymbolStates.NO_WIN ? HTHSymbolStates.NO_WIN : this.symbolState;
        }, 0);

        return tl;
    }

    public setInteractive(val: boolean): void {
        if (val && this.isEnhancerOpen && this.revealedSymbol) {
            if (this.revealedSymName.includes("M") && this.revealedSymName !== "MAX" || this.revealedSymName.includes("L"))
                (<HTHNormalSymbol>this.revealedSymbol).setInteractive(val);
        }
    }

}